module.exports = __webpack_public_path__ + "static/media/edit.55013553.svg";